import axios, { AxiosResponse } from 'axios';

axios.defaults.timeout = 4000;
const CORS_PROXY_URL = 'https://api.allorigins.win/raw?url=';
const IPFS_GATEWAY = 'https://ipfs.io/';

export const wrapUrlWithCorsProxy = (uri: string): string => `${CORS_PROXY_URL}${uri}`;

export const fetchWithErrorHandling = async <E>(uri: string): Promise<AxiosResponse<E>> => {
  try {
    //ERC1155 subgraph returns metadata starting with '/ipfs'
    if (uri.startsWith('/ipfs')) {
      return await axios.get(`${IPFS_GATEWAY}${uri}`);
    }
    return await axios.get(uri);
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with non-200 status
      console.error('Error while trying to fetch URI: ', error.response.data);
    } else if (error.request) {
      // The request was made but no response was received, probably CORS
      if (uri.startsWith('ipfs://')) {
        return fetchWithErrorHandling(resolveIPFSUri(uri) || uri);
      } else if (!uri.startsWith(CORS_PROXY_URL)) {
        return fetchWithErrorHandling(wrapUrlWithCorsProxy(uri));
      } else {
        console.error(`Request didn't go through: `, error.request);
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error while trying to fetch URI: ', error.message);
    }
    throw error;
  }
};

export const resolveIPFSUri = (uri: string): string | undefined => {
  if (uri.startsWith('https://gateway.pinata.cloud')) {
    return uri.replace('https://gateway.pinata.cloud/', IPFS_GATEWAY);
  } else if (uri.startsWith('ipfs://ipfs/')) {
    return uri.replace('ipfs://ipfs/', `${IPFS_GATEWAY}ipfs/`);
  } else if (uri.startsWith('ipfs://')) {
    return uri.replace('ipfs://', `${IPFS_GATEWAY}ipfs/`);
  }
};
